import notifier from '@/notifier'
import api from '@/api'
import { isObject, transform } from 'lodash'

const omit = function (obj) {
  function omitFromObject (obj) {
    return transform(obj, function (result, value, key) {
      if (value === '' || value === undefined || value === null) {
        return
      }

      result[key] = isObject(value) ? omitFromObject(value) : value
    })
  }

  return omitFromObject(obj)
}

export default {
  namespaced: true,
  state: {
    updating: false
  },
  actions: {
    async update ({ state, commit }, announcement) {
      commit('setUpdating', true)

      if (!this.getters['errors/getErrorsByProductId'](announcement.productId)) {
        try {
          await api.mercadoLivre.updateProduct(omit(announcement))

          notifier.success('Anúncio atualizado com sucesso', 'Atualizado')
          commit('setUpdating', false)

          return
        } catch (error) {
          if (error.response.data.message.indexOf('Validation failed') !== -1) {
            commit('setErrors', {
              announcement: announcement,
              errors: error.response.data.data
            })
          }

          notifier.error('Falha na alteração do anúncio!', 'Falha')
          commit('setUpdating', false)

          throw error
        }
      }
      notifier.error('Falha na alteração do anúncio!', 'Falha')
      commit('setUpdating', false)
    },
    async activate ({ state, commit }, announcement) {
      return api.mercadoLivre.activateAnnouncement(announcement._id.$oid, announcement.account.identifier)
        .then(product => commit('setStatus', { announcement, status: product.status }))
    },
    async pause ({ state, commit }, announcement) {
      return api.mercadoLivre.pauseAnnouncement(announcement._id.$oid, announcement.account.identifier)
        .then(product => commit('setStatus', { announcement, status: product.status }))
    }
  },
  mutations: {
    setUpdating (state, updating) {
      state.updating = updating
    },
    setErrors (state, { announcement, errors }) {
      for (let i in errors) {
        if (!errors.hasOwnProperty(i)) {
          continue
        }
        const error = errors[i]

        this._actions['errors/addError'][0]({
          productId: announcement.productId,
          sku: announcement.productId,
          property: error.property,
          error: {
            message: error.constraint,
            value: error[error.constraint]
          }
        })
      }
    },
    setStatus (state, { announcement, status }) {
      announcement.status = status
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/panel/editAnnouncement.js